import {
  getVariantInventoryTotal,
  getVariantSizeStock,
  getVariantTotalStock,
  hasVariantInventory,
} from './productInventory';

export const normalizeOutOfStockFlag = (value) =>
  value === true || String(value || '').trim().toLowerCase() === 'true';

export const getNormalizedStock = (value) => {
  const normalizedValue = Number(value);
  return Number.isFinite(normalizedValue) ? normalizedValue : 0;
};

export const isProductUnavailable = (product = {}) => {
  if (normalizeOutOfStockFlag(product?.isOutOfStock)) return true;
  if (hasVariantInventory(product)) return getVariantInventoryTotal(product) <= 0;
  return getNormalizedStock(product?.stock) <= 0;
};

export const getProductAvailabilityError = (product = {}, item = {}) => {
  if (!product) return '';

  if (isProductUnavailable(product)) {
    return 'This product is currently out of stock and cannot be ordered.';
  }

  const requestedQuantity = Math.max(0, Number(item?.quantity) || 0);
  if (!requestedQuantity) return '';

  const colorName = String(item?.color || '').trim();
  const sizeName = String(item?.size || '').trim();

  if (hasVariantInventory(product)) {
    const availableStock = sizeName
      ? getVariantSizeStock(product, colorName || undefined, sizeName)
      : getVariantTotalStock(product, colorName || undefined);

    if (availableStock !== null && requestedQuantity > availableStock) {
      return sizeName
        ? `${colorName || 'Default'} size ${sizeName} only has ${availableStock} left.`
        : `${colorName || 'Default'} only has ${availableStock} left.`;
    }

    return '';
  }

  const productStock = getNormalizedStock(product?.stock);
  if (requestedQuantity > productStock) {
    return `Only ${productStock} total left for this product.`;
  }

  return '';
};

export const getProductStockLabel = (product = {}) => {
  if (normalizeOutOfStockFlag(product?.isOutOfStock)) {
    return 'Out of stock';
  }

  const normalizedStock = hasVariantInventory(product)
    ? getVariantInventoryTotal(product)
    : getNormalizedStock(product?.stock);

  if (normalizedStock <= 0) return 'Out of stock';
  if (normalizedStock <= 5) return `${normalizedStock} pairs left`;
  return 'Ready now';
};
